import { DiscussionComponent, DiscussionHistoryInline } from "../../../components/atomic/discussionComponent";
import { Metadata } from "../../../types/Metadata";

export const FinalComment = ({
  metadata,
  onOpenMetadataModal,
}: {
  metadata: Metadata;
  onOpenMetadataModal?: () => void;
}) => {

  return (
    <div className="rounded-[10px] border border-[var(--sc-border)] bg-[var(--sc-surface)] overflow-hidden">
      <div className="flex items-center justify-between px-5 py-4 border-b border-[var(--sc-border)]">
        <button
          type="button"
          onClick={onOpenMetadataModal}
          className="text-[15px] font-semibold text-[var(--sc-text)] hover:text-[#F4A832] transition-colors"
          title="Edytuj metadane"
        >
          Komentarz końcowy
        </button>
        <DiscussionHistoryInline resourceId={metadata.reportId} />
      </div>
      <div className="px-5 py-4">
        <p className="text-sm text-[var(--sc-muted)] whitespace-pre-wrap">
          {metadata.finalComment || "Brak komentarza"}
        </p>
      </div>
    </div>
  );
};
